import OrganizationsReportModal from "./OrganizationsReportModal"

export default OrganizationsReportModal
